<template>
  <div class="card">
    <header v-if="$slots.title" class="card-header">
      <p class="card-header-title">
        <slot name="title" />
      </p>
    </header>
    <div class="card-content">
      <div class="content">
        <slot />
      </div>
    </div>
    <footer v-if="$slots.footer" class="card-footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<style lang="sass" scoped>
.card
  user-select: none

.card-content
  width: 100%
  height: 100%
  .content
    width: 100%
    height: 100%
</style>